import React from 'react';
import styles from './SocialMediaLinks.module.css';
import facebookIcon from '../../assets/images/facebooklogo.png';
import instagramIcon from '../../assets/images/instagramlogo.png';
import youtubeIcon from '../../assets/images/youtubelogo.png';
import tiktokIcon from '../../assets/images/tiktoklogo.png';
import spotifyIcon from '../../assets/images/spotifylogo.png';
import appleMusicIcon from '../../assets/images/AppleMusic.png'; // Ensure the paths and extensions are correct

const SocialMediaLinks: React.FC = () => {
    return (
        <div className={styles.socialMediaContainer}>
            <a href="https://www.facebook.com/mobdramaband" target="_blank" rel="noopener noreferrer">
                <img src={facebookIcon} alt="Facebook" className={styles.icon} />
            </a>
            <a href="https://www.instagram.com/mobdrama" target="_blank" rel="noopener noreferrer">
                <img src={instagramIcon} alt="Instagram" className={styles.icon} />
            </a>
            <a href="https://www.youtube.com/mobdramaIL" target="_blank" rel="noopener noreferrer">
                <img src={youtubeIcon} alt="YouTube" className={styles.icon} />
            </a>
            <a href="https://www.tiktok.com/@mobdramamusic" target="_blank" rel="noopener noreferrer">
                <img src={tiktokIcon} alt="TikTok" className={styles.icon} />
            </a>
            <a href="https://open.spotify.com/artist/0jbzNFZAot6ah6zU2z0W5x?si=S2HnSmuLTtKGNkAVC2XQgg" target="_blank" rel="noopener noreferrer">
                <img src={spotifyIcon} alt="Spotify" className={styles.icon} />
            </a>
            <a href="https://music.apple.com/us/artist/mob-drama/1737520279" target="_blank" rel="noopener noreferrer">
                <img src={appleMusicIcon} alt="Apple Music" className={styles.icon} />
            </a>
            {/* Add other social media links as needed */}
        </div>
    );
};

export default SocialMediaLinks;
